export const orchestrationResponseActions = {
  getResponseValueWithOther: 'getResponseValueWithOther',
  linkAppenderResponse: 'linkAppenderResponse',
  buildAllPartiesResponse: 'buildAllPartiesResponse',
  provisionalWithOptions: 'provisionalWithOptions',
}
